<mat-toolbar style="justify-content: center">
  <app-hash-generator></app-hash-generator>
</mat-toolbar>
